import { useMemo } from 'react';
import { useFeatureFlagEnabled, useFeatureFlagPayload } from '@posthog/react';
import useAuth from '../../../utils/auth';
import { FeatureFlags } from '../../../utils/featureFlags';
import { HmrcDataBranchValues } from '../../../types/core.type';
import parseTooltipPayload from '../utils';

export default function useHmrcDataToggle() {
  const { hmrcDataToggle } = useAuth();
  const isFlagEnabled = useFeatureFlagEnabled(FeatureFlags.hmrcDataToggleEnabled) || false;
  const payload = useFeatureFlagPayload(FeatureFlags.hmrcDataToggleEnabled);
  const tooltip = useMemo(() => parseTooltipPayload(payload), [payload]);

  return {
    isVisible: isFlagEnabled && hmrcDataToggle.isDisplayed && hmrcDataToggle.isEnabled,
    isOn: hmrcDataToggle.branch === HmrcDataBranchValues.On,
    tooltip,
  };
}
